import React from 'react';
import routes from '../routes';
import ItemCard from './ItemCard/ItemCard';
import { useText } from '../hooks/useText';

const CheckInCard = ({
  image, icon,
}) => (
  <ItemCard
    image={image}
    title={useText('SPLASH.MAIN_CHECK_IN_TITLE')}
    description={useText('SPLASH.MAIN_CHEK_IN_DESCRIPTION')}
    url={routes.CheckIn}
    icon={icon}
    qaId="check-in"
  />
);

export default CheckInCard;
